import { render } from "./omoList.vue?vue&type=template&id=25fa9370&scoped=true&ts=true"
import script from "./omoList.vue?vue&type=script&lang=ts"
export * from "./omoList.vue?vue&type=script&lang=ts"

import "./omoList.vue?vue&type=style&index=0&id=25fa9370&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/prod-hys-h5-5.0/hys-h5-5.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25fa9370"]])

export default __exports__